import { render, staticRenderFns } from "./AttentionNeeded.vue?vue&type=template&id=552d6d53&scoped=true"
import script from "./AttentionNeeded.vue?vue&type=script&lang=js"
export * from "./AttentionNeeded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552d6d53",
  null
  
)

export default component.exports